import { useEffect, useState } from "react";
import api from "../../../../../../../services/api";
import { IItemHistorico } from "../../../../types";
import { ExpandedContent, Separator } from "./styles";
import BlocoOrientacao from "../OrientacaoPreviaCriada/Blocos/BlocoOrientacao";

interface ExpandedContentProps {
    item: IItemHistorico;
    onNavigateToFile?: (fileId: number) => void;
}

export default function ExpandedContentOrientacaoPreviaEditada({ item }: ExpandedContentProps) {
    const [orientacaoAntes, setOrientacaoAntes] = useState<string>("");
    const [orientacaoDepois, setOrientacaoDepois] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        if (!item?.id) {
            setLoading(false);
            return;
        }

        const carregarDados = async () => {
            try {
                setLoading(true);

                const response = await api.get(`log-historico/${item.id}`);

                if (response.data.status === "success") {
                    const logs = response.data.result || [];
                    const logOrientacao = logs.find(
                        (log: any) => log.entidade_nome === "proposta"
                    );

                    if (logOrientacao) {
                        const antes = logOrientacao.dados_antes?.orientacoes
                            ? String(logOrientacao.dados_antes.orientacoes)
                            : "";
                        const depois = logOrientacao.dados_depois?.orientacoes
                            ? String(logOrientacao.dados_depois.orientacoes)
                            : "";

                        setOrientacaoAntes(antes);
                        setOrientacaoDepois(depois);
                    } else {
                        setOrientacaoAntes("");
                        setOrientacaoDepois("");
                    }
                } else {
                    setOrientacaoAntes("");
                    setOrientacaoDepois("");
                }
            } catch (_error) {
                setOrientacaoAntes("");
                setOrientacaoDepois("");
            } finally {
                setLoading(false);
            }
        };

        carregarDados();
    }, [item.id]);

    if (loading) {
        return (
            <ExpandedContent>
                <div style={{ padding: "20px", textAlign: "center", color: "var(--c64748b)" }}>
                    Carregando dados...
                </div>
            </ExpandedContent>
        );
    }

    if (!orientacaoAntes && !orientacaoDepois) {
        return null;
    }

    return (
        <ExpandedContent>
            <Separator />
            <BlocoOrientacao orientacaoAntes={orientacaoAntes} orientacaoDepois={orientacaoDepois} />
        </ExpandedContent>
    );
}


